import { IFont } from "./IFont";

export class Font {
  constructor(public family: string = "ＭＳ ゴシック", public size: number = 9) {}

  clone(): Font {
    return new Font(
      this.family,
      this.size
    );
  }

  static from(source: IFont): Font {
    if (!source) {
      return null;
    }
    return new Font(source.family, source.size);
  }

  static to(source: Font): IFont {
    if (!source) {
      return null;
    }
    return {
      family: source.family,
      size: source.size,
    };
  }
}
